import { render, staticRenderFns } from "./Slider.vue?vue&type=template&id=d65b1958&"
import script from "./Slider.vue?vue&type=script&lang=ts&"
export * from "./Slider.vue?vue&type=script&lang=ts&"
import style0 from "./Slider.vue?vue&type=style&index=0&id=d65b1958&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports